import type { FC } from "react";

import type { RegistrationStatus as RegistrationStatusType } from "../api/registrations.types";
import { StatusChip, type Colors } from "./StatusChip";
import type { Theme } from "@mui/material/styles";

export const statusColors: Record<RegistrationStatusType["status"], Colors & { dot: (theme: Theme) => string }> = {
  completion: {
    background: theme => theme.palette.teal["100"],
    border: theme => theme.palette.teal["400"],
    text: theme => theme.palette.teal["900"],
    dot: theme => theme.palette.teal["500"],
  },
  draft: {
    background: theme => theme.palette.purple["50"],
    border: theme => theme.palette.purple["200"],
    text: theme => theme.palette.purple["800"],
    dot: theme => theme.palette.purple["400"],
  },
  done: {
    background: theme => theme.palette.brandGreen["100"],
    border: theme => theme.palette.brandGreen["400"],
    text: theme => theme.palette.brandGreen["900"],
    dot: theme => theme.palette.brandGreen["500"],
  },
  review: {
    background: theme => theme.palette.brandOrange["200"],
    border: theme => theme.palette.brandOrange["400"],
    text: theme => theme.palette.brandOrange["900"],
    dot: theme => theme.palette.brandOrange["500"],
  },
  audit: {
    background: theme => theme.palette.grey["200"],
    border: theme => theme.palette.grey["400"],
    text: theme => theme.palette.text.primary,
    dot: theme => theme.palette.text.tertiary,
  },
};

export const RegistrationStatusChip: FC<{ status: RegistrationStatusType["status"] }> = ({ status }) => {
  const colors = statusColors[status];
  if (!colors) {
    return null;
  }

  return <StatusChip colors={colors} labelKey={`RegistrationStatus.${status}`} />;
};
